/**
 * statementCaption — le texte qui accompagne un énoncé non écrit (une photo, un PDF, un lien), tel que le
 * centre du live du masteur le montre (pur) ; lu par `<ActivityStatement captionCut>`, testé à côté.
 *
 * Le port de `MaterialDisplayModal.js` (`subheaderText`, branche `noModal`, celle du centre du live) : un
 * texte de plus de 100 caractères se montre coupé, et se déplie au toucher. L'ancien coupait alors à
 * 45 caractères suivis de « ... » (le seuil de 100 est celui de `noModal`, la coupe celle de la fiche en
 * fenêtre, restée la même dans les deux branches) : on garde ces deux nombres tels quels.
 */

/** Jusqu'à cette longueur, le texte se montre entier (`noModal ? 100 : 45`). */
export const STATEMENT_CAPTION_FULL_UP_TO = 100
/** Au-delà, ce qu'on en montre replié (`substring(0, 45) + "..."`). */
export const STATEMENT_CAPTION_CUT_AT = 45

export type StatementCaption = {
    /** Ce qu'on montre. */
    text: string
    /** Le texte se coupe : le toucher le déplie ou le replie. */
    foldable: boolean
}

export function statementCaption(text: string, expanded: boolean): StatementCaption {
    const foldable = text.length > STATEMENT_CAPTION_FULL_UP_TO
    return {
        text: foldable && !expanded ? `${text.substring(0, STATEMENT_CAPTION_CUT_AT)}...` : text,
        foldable,
    }
}
